import { ARTICLE_ADD } from './Articles.types';

export function articleAdd(article: string) {
    return {
        type: ARTICLE_ADD,
        article: article,
    };
}
